import {filter, lazy, transpose} from './lang.js';
import {add} from './lazy.js';
import {alt} from './alt.js';

export const atranspose = (term) => {
    let alty = alt(term);
    return (...args) => {
        if (!args[0]) {
            return filter(false);
        }
        let _term = alty(...args);
        return transpose(add(_term, transpose()));
    }
};

